var React = require( 'react' );
var createReactClass = require('create-react-class');

var CheckboxInput = createReactClass({

    handleChange: function(event) {
      var userResponse = {
          tag: this.props.choice.tag,
          text: this.refs.textEntryTextArea && this.refs.textEntryTextArea.value || this.props.choice.label, // eslint-disable-line
          value: event.target.value*1,
          unique: this.props.choice.unique,
          option: {
              selected: event.target.checked,
              allowMulti: this.props.allowMulti
          }
      };
      this.props.handleResponse(userResponse);
    },

    buildLabel: function(){
        const { choice: { image = '', label = '' } = {} } = this.props;
        if (image) {
            return <img src={'https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/survey/' + image} alt={label} />;
        // Remove fill-in input box for 'other' options
        // }else if(this.props.choice.tag && this.props.choice.tag.startsWith('other')){
        //    return <input type="text" ref="textEntryTextArea" value={this.props.userResponse.text || ''} onChange={this.textChange} placeholder={this.props.choice.label || 'Other (please specify)'} />;
        } else {
            return label;
        }
    },

    textChange: function (event) {
        var userResponse = {
            tag: this.props.choice.tag,
            text: event.target.value,
            value: this.props.choice.value,
            unique: this.props.choice.unique,
            option: {
                selected: event.target.value ? true : false,
                allowMulti: this.props.allowMulti
            }
        };
        this.props.handleResponse(userResponse);
    },

    render: function () {
        const { choice: { tag = '', value = '' } = {} } = this.props;
        var checked = Object.keys(this.props.userResponse).length > 0;

        var id = 'choice_' + tag + '_' + value;
        const inputType = (this.props.allowMulti) ? 'checkbox' : 'radio';

        return (
            <li className={this.props.disabled ? 'disabled' : ''}>
                <div className={inputType}>
                    <input 
                        type={inputType}
                        id={id}
                        name={id}
                        checked={checked}
                        disabled={this.props.disabled}
                        onChange={this.handleChange}
                        value={value} />

                    <label htmlFor={id}>
                        <i className="ion-checkmark" />
                    </label>
                </div>
                <label htmlFor={id}>
                    {this.buildLabel()}
                </label>
            </li>
        );
    }
});

module.exports = CheckboxInput;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/select/checkBoxItem.jsx